import { PlayerCharacter, StoryChapter, StoryCharacter, StoryLocation, StoryUniverse } from "@/lib/types/story";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StoryState {
    universeId: string | null;
    universe: Partial<StoryUniverse> | null;
    currentChapterId: string | null;
    currentChapter: Partial<StoryChapter> | null;
    playerCharacter: Partial<PlayerCharacter> | null;
    currentLocation: Partial<StoryLocation> | null;
    locationCharacters: Partial<StoryCharacter>[] | null;
}

const initialState: StoryState = {
    universeId: null,
    universe: null,
    currentChapterId: null,
    currentChapter: null,
    playerCharacter: null,
    currentLocation: null,
    locationCharacters: null,
}

export const storySlice = createSlice({
    name: 'story',
    initialState,
    reducers: {
        setUniverse: (state, action: PayloadAction<Partial<StoryUniverse>>) => {
            state.universe = action.payload;
            state.universeId = action.payload._id?.toString();
        },
        setCurrentChapter: (state, action: PayloadAction<Partial<StoryChapter>>) => {
            state.currentChapter = action.payload;
            state.currentChapterId = action.payload?._id?.toString();
        },        
        setPlayerCharacter: (state, action: PayloadAction<Partial<PlayerCharacter>>) => {
            state.playerCharacter = action.payload;
        },
        setCurrentLocation: (state, action: PayloadAction<Partial<StoryLocation>>) => {
            state.currentLocation = action.payload;
        },
        setLocationCharacters: (state, action: PayloadAction<Partial<StoryCharacter>[]>) => {
            state.locationCharacters = action.payload;
        },
    }
});

export const { setUniverse, setCurrentChapter, setPlayerCharacter, setCurrentLocation, setLocationCharacters } = storySlice.actions;
export default storySlice.reducer;